import React from "react";

const Map = () => {
  return (
    <div style={{ width: "100%", height: "500px", padding: "10px" }}>
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d112200.7358614954!2d77.3180816928506!3d28.501433151160086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x390ceb3ca34d3b49%3A0x6278c82cdc009587!2soffice%20no.%20%3A-%203%2C%202nd%20floor%2C%20Aykon%20Tower%2C%20Noida-Greater%20Noida%20Expy%2C%20Sector%20135%2C%20Noida%2C%20Uttar%20Pradesh%20201304!3m2!1d28.501458!2d77.4004844!5e0!3m2!1sen!2sin!4v1739807706272!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default Map;
